<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      v-el-dialog-drag
      visible
      show-close
      width="750px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :versionCode="editFormDialogOptions.code"
        @close="closeEditFormDialog"
        @reload="reload"
      >
      </edit-form>
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          v-if="!editFormDialogOptions.disabled"
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditForm from '../edit-form/edit-form'
export default {
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sysVersionListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({type, code = ''}) {
      const types = {
        edit: this.$l('form_label_sysVersion_edit') || '编辑版本信息',
        add: this.$l('form_label_sysVersion_add') || '新增版本信息',
        detail: this.$l('form_label_sysVersion_detail') || '版本信息详情',
      }

      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
